import { setShowClientContactModal } from '../../../State/showClientContactModal';

export default () => (dispatch) => {

  dispatch(setShowClientContactModal(true));

}